/* eslint-disable react/prop-types */

import { useState, useEffect, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import moment from "moment";
import _ from "lodash";

import Card from "@mui/material/Card";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiBadgeDot from "components/SuiBadgeDot";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import config from "configs";
import { Post } from "api";

function PostList({ mode }) {
  const history = useHistory();
  const [tabsOrientation] = useState("horizontal");
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const { postTypeId } = useParams()
  const { pathname, state } = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  const columns = [
    { Header: t("Posts"), accessor: "name", width: "40%" },
    { Header: t("Slug"), accessor: "slug" },
    {
      Header: t("status"),
      accessor: "status",
      width: "7%",
      Cell: ({ value }) => {
        if (!value) return <></>;
        let color = "light";
        let text = "draft";
        if (value === "3") {
          color = "success";
          text = "Published";
        } else if (value === "2") {
          color = "info";
          text = "Scheduled";
        }
        return (
          <SuiBox ml={-1.325}>
            <SuiBadgeDot size="xs" color={color} badgeContent={t(text)} />
          </SuiBox>
        );
      },
    },
    { Header: t("Created On"), accessor: "createdAt" },
    { Header: t("Editted On"), accessor: "updatedAt" },
  ];

  const [rawData, setRawData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const tableData = useMemo(() => {
    const data = { columns, rows: [] };

    data.rows = [];
    _.get(rawData, "results", []).forEach((result) => {
      data.rows.push({
        id: result.id,
        name: result.titleSC,
        slug: result.slugSC,
        status: result.status,
        createdAt: result.createdAt
          ? moment(result.createdAt).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        updatedAt: result.updatedAt
          ? moment(result.updatedAt).format("YYYY-MM-DD hh:mm:ss A")
          : "",
        style: {
          cursor: 'pointer'
        },
      });
    });

    return data;
  }, [rawData]);

  useEffect(() => {
    if (postTypeId) {
      (async () => {
        setIsLoading(true);
        try {
          const params = { page, pageSize: config.defaults.PAGE_SIZE, postTypeId };
          if (search) {
            params['keyword'] = search;
          }
          if (activeTab) {
            params.status = activeTab;
          }
          const rsp = await Post.getAll(params);
          const { data } = rsp;
          setRawData(data);
          const { total, pageSize } = data;
          setPageCount(Math.ceil(total / pageSize));
        } catch (err) {
          console.error(err);
        }
        setIsLoading(false);
      })();
    }
  }, [page, search, activeTab]);

  return (
    <>
      <Helmet>
        <title>{t("Post")}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5} width="100%">
          <SuiBox width="100%">
            <Card>
              <SuiBox p={1} lineHeight={1} />
              {isLoading ? (
                <>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <DataTable
                  pageCount={pageCount}
                  table={tableData}
                  showTotalEntries={false}
                  entriesPerPage={false}
                  isSorted={false}
                  onPageChange={setPage}
                  page={page}
                  canSearch
                  onSearch={setSearch}
                  defaultGlobalFilter={search}
                  onRowClick={(row) => {
                    history.push(`/post-types/${postTypeId}/posts/edit/${row.original.id}`, state);
                  }}
                  createButton={mode === "view" ? undefined : (
                    <SuiButton
                      variant="gradient"
                      color="info"
                      onClick={() => {
                        history.push({
                          pathname: pathname + "/new",
                          state,
                        });
                      }}
                    >
                      {t("New Post")}
                    </SuiButton>
                  )}
                  tabFilter={<SuiBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    width="50%"
                    style={{ margin: 'auto' }}
                  >
                    <SuiBox width="100%">
                      <AppBar position="static">
                        <Tabs
                          orientation={tabsOrientation}
                          value={activeTab}
                          onChange={(...args) => {
                            setActiveTab(args[1]);
                            setPage(1);
                          }}
                        >
                          <Tab style={{ padding: 10 }} label={t("All")} />
                          <Tab label={t("Draft")} />
                          <Tab label={t("Scheduled")} />
                          <Tab label={t("Published")} />
                        </Tabs>
                      </AppBar>
                    </SuiBox>
                  </SuiBox>}
                />
              )}
            </Card>
          </SuiBox>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default PostList;
